import { Outlet } from "react-router-dom";
import Navbar from "./Navbar";

const Layout = () => {
	return (
		<div className="w-screen h-screen bg-black flex flex-col">
			<div className="px-5 h-16">
				<Navbar />
			</div>
			<div className="h-[calc(100vh-64px)] pb-5">
				<Outlet />
			</div>
		</div>
	);
};

export default Layout;
